import { computed, inject, Injectable } from '@angular/core';
import { CandidateSearchStore } from '../candidate-search/candidate-search.store';
import { CandidateSearch } from '../../models/candidate-search.models';

export interface CandidateSearchSelectors {
    candidates: () => CandidateSearch[];
    selectedCandidate: () => CandidateSearch | null;
    isCandidateSelected: () => boolean;
}

@Injectable({ providedIn: 'root' })
export class CandidateSearchSelectorsService {
    private readonly candidateSearchStore = inject(CandidateSearchStore);

    readonly candidateSearchSelectors: CandidateSearchSelectors = {
        candidates: computed(() => this.candidateSearchStore.candidates()),
        selectedCandidate: computed(() => this.candidateSearchStore.selectedCandidate()),
        isCandidateSelected: computed(() => this.candidateSearchStore.isCandidateSelected())
    };
}
